import { ProgramTypeVariants, WarehouseChannelBadgeStatus, StockVariants, DeliveryStatus } from "../../constants.js";
import { getProductNavigationUrl } from "../lib.js";
import { PRODUCT_CLASS_TYPES } from "../../searchService/LucidWorks/constants.js";
import { isBD } from "../../../utils/businessType.lib.js";
import { isValidUrl, hasMembershipId } from "../../../utils/index.js";
import { productActionsVariant } from "../../../components/Product/ProductTileV2/constants.js";
import { ATTRIBUTE_DELIVERY_TYPE, ATTRIBUTE_WAREHOUSE_PICK_UP_VALUE, REPLACEMENT_TYPE, PRODUCT_CLASS_TYPE_TOBACCO, AS400_CAT_CODE_EBB, AS400_DEPT_NAME_11, ATTRIBUTE_HIDE_PRICE_RANGE_KEY, ATTRIBUTE_1_VALUE, ATTRIBUTE_SWATCH_IMAGE_KEY, ATTRIBUTE_BUNDLE } from "./constants.js";
const programTypeToLowercase = (item) => {
  var _a;
  return (_a = item == null ? void 0 : item.programTypes) == null ? void 0 : _a.map((programType) => programType.toLowerCase());
};
const getInWarehouseAvailabilityText = (item) => {
  return programTypeToLowercase(item).includes(
    ProgramTypeVariants.TWO_DAY_DELIVERY.toLowerCase()
  );
};
const getProgramTypeAvailability = (programTypeObj) => {
  return (programTypeObj == null ? void 0 : programTypeObj.availability) === StockVariants.IN_STOCK || (programTypeObj == null ? void 0 : programTypeObj.availability) === StockVariants.LOW_STOCK;
};
const getDeliveryStatusFromInventory = (wioWarehouseEnabled, bopiwWarehouseEnabled, inventoryData) => {
  return inventoryData == null ? void 0 : inventoryData.some((item) => {
    const { programTypes } = item;
    const locationControlledInventoryAvailable = getProgramTypeAvailability(
      (programTypes == null ? void 0 : programTypes.locationControlledInventory) || {}
    );
    const siteControlledInventoryAvailable = getProgramTypeAvailability(
      (programTypes == null ? void 0 : programTypes.siteControlledInventory) || {}
    );
    const wioWarehouseInventoryCheck = wioWarehouseEnabled && getProgramTypeAvailability((programTypes == null ? void 0 : programTypes.inWarehouse) || {});
    const bopiwWarehouseInventoryCheck = bopiwWarehouseEnabled && (getProgramTypeAvailability((programTypes == null ? void 0 : programTypes.inWarehouse) || {}) || getProgramTypeAvailability(
      (programTypes == null ? void 0 : programTypes.useWarehouseInventory) || {}
    ));
    return siteControlledInventoryAvailable || locationControlledInventoryAvailable || Boolean(wioWarehouseInventoryCheck || bopiwWarehouseInventoryCheck);
  });
};
const getDeliveryChannelBadgeData = (catalogItem, bopiwWarehouseEnabled, wioWarehouseEnabled, inventoryData) => {
  if (!inventoryData || !inventoryData.length) return null;
  const { isBuyable, startDate } = catalogItem;
  const isLocationOrSiteControlled = inventoryData == null ? void 0 : inventoryData.some(
    (item) => {
      var _a, _b;
      return ((_a = item == null ? void 0 : item.programTypes) == null ? void 0 : _a.locationControlledInventory) || ((_b = item == null ? void 0 : item.programTypes) == null ? void 0 : _b.siteControlledInventory);
    }
  );
  if (isLocationOrSiteControlled && isBuyable) {
    const currentTimeStamp = /* @__PURE__ */ new Date();
    const parsedStartDate = startDate && new Date(startDate);
    if (parsedStartDate && parsedStartDate < currentTimeStamp) {
      const availabilityStatus = getDeliveryStatusFromInventory(
        wioWarehouseEnabled,
        bopiwWarehouseEnabled,
        inventoryData
      );
      return availabilityStatus ? DeliveryStatus.Available : DeliveryStatus.OutOfStock;
    } else {
      return DeliveryStatus.ComingSoon;
    }
  } else {
    return DeliveryStatus.Unavailable;
  }
};
const getFsaEligibility = (childData) => {
  var _a, _b;
  if (!childData || !((_a = childData.catalogData) == null ? void 0 : _a.length)) return false;
  return (_b = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _b.some((item) => item.isFsa);
};
const getChdiEligibility = (childData) => {
  var _a, _b;
  if (!childData || !((_a = childData.catalogData) == null ? void 0 : _a.length)) return false;
  return (_b = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _b.some((item) => item.isChd);
};
const getColorSwatchesData = (translationsConfig, imageConfig, item, childData, featureToggleConfig) => {
  var _a;
  if (!(item == null ? void 0 : item.isSwatchable) || !childData || !((_a = childData.catalogData) == null ? void 0 : _a.length)) {
    return null;
  }
  const { domainUrl } = imageConfig || {};
  const { bfSwatchURL, extension } = (translationsConfig == null ? void 0 : translationsConfig.swatchControls) || {};
  const { descriptions, id } = item;
  const colorSwatchesData = [];
  childData.catalogData.forEach((cItem) => {
    var _a2, _b;
    const { productAttributes } = cItem;
    (_b = (_a2 = productAttributes == null ? void 0 : productAttributes[0]) == null ? void 0 : _a2.object) == null ? void 0 : _b.forEach((aItem) => {
      var _a3, _b2;
      if (ATTRIBUTE_SWATCH_IMAGE_KEY in aItem && aItem[ATTRIBUTE_SWATCH_IMAGE_KEY]) {
        const { swatchImage, value, key } = aItem;
        if (!(colorSwatchesData == null ? void 0 : colorSwatchesData.find((s) => s.id === swatchImage))) {
          colorSwatchesData == null ? void 0 : colorSwatchesData.push({
            attributeValue: value || "",
            id: swatchImage,
            label: key || "",
            pdpNavigationUrl: getProductNavigationUrl(
              ((_a3 = descriptions == null ? void 0 : descriptions[0]) == null ? void 0 : _a3.object.shortDescription) || "",
              id || "",
              domainUrl,
              swatchImage,
              key,
              (_b2 = featureToggleConfig == null ? void 0 : featureToggleConfig.enableBModPDPNavigationUrl) == null ? void 0 : _b2.isEnabled
            ),
            productImageUrl: getImageUrlPCP(item),
            swatchImageUrl: `${bfSwatchURL}${swatchImage}${extension}`
          });
        }
      }
    });
  });
  return (colorSwatchesData == null ? void 0 : colorSwatchesData.length) ? colorSwatchesData : null;
};
const getReplacementItemNumber = (replacement) => {
  if (!replacement) return null;
  return (replacement == null ? void 0 : replacement.type) === REPLACEMENT_TYPE ? replacement == null ? void 0 : replacement.item : null;
};
const parseBatchedItemResponse = async (itemNumber, response) => {
  const batchedItemNumbers = itemNumber.split(",");
  const batchApiResponseData = await response.json();
  const parsedBatchData = batchedItemNumbers == null ? void 0 : batchedItemNumbers.map(
    (itemNumber2) => {
      var _a;
      const itemResponse = batchApiResponseData == null ? void 0 : batchApiResponseData.productData.find(
        (item) => item.id === itemNumber2
      );
      const inventoryItemNumbers = ((_a = itemResponse == null ? void 0 : itemResponse.childCatalogData) == null ? void 0 : _a.map((item) => item.id).map(Number)) || [];
      return {
        inventoryItemNumbers,
        productApiResponseData: { productData: [itemResponse] },
        itemNumber: itemNumber2
      };
    }
  );
  return parsedBatchData;
};
const getCompareProductButtonData = (item) => {
  const { isComparable } = item;
  const isTwoDayDeliveryKeyExists = checkProgramTypeKeyExists(
    item,
    ProgramTypeVariants.TWO_DAY_DELIVERY
  );
  return !isTwoDayDeliveryKeyExists && isComparable;
};
const getReviewRatingData = (item, translationsObj) => {
  var _a;
  const { isEligibleForReviews, ratingScore, ratingCount } = item || {};
  const { translations } = translationsObj || {};
  if (isEligibleForReviews) {
    const parsedRating = ratingScore == null ? void 0 : ratingScore.toFixed(2);
    const mapObj = {
      "{rating}": parsedRating,
      "{total}": `${ratingCount}`
    };
    const ariaLabelText = (_a = translations == null ? void 0 : translations.averageratingarialabel) == null ? void 0 : _a.replace(
      /{rating}|{total}/gi,
      (matched) => mapObj[matched]
    );
    return {
      ariaLabel: +parsedRating ? ariaLabelText : translations == null ? void 0 : translations.noreviewsarialabel,
      reviewCount: ratingCount,
      value: +parsedRating
    };
  }
  return null;
};
const checkProgramTypeKeyExists = (item, key) => {
  return programTypeToLowercase(item).includes(key.toLowerCase());
};
const getInWareHouseChannelBadgeData = (item, enabledWarehousesListConfig, cookieContext, showMultiVariantsAvailability = false, hasSingleSku, inventoryData) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const { warehouse, userLocation } = cookieContext;
  const { nearestWarehouse } = warehouse;
  const { city } = userLocation;
  const isWarehouseEnabled = (_a = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesList) == null ? void 0 : _a.some(
    (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
  );
  const isBOPIWWarehouseEnabled = (_b = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesBOPIWList) == null ? void 0 : _b.some(
    (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
  );
  const isWIOWarehouseEnabled = (_c = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesWIOList) == null ? void 0 : _c.some(
    (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
  );
  const isBOPIMEnabled = (_d = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesBOPIMList) == null ? void 0 : _d.some(
    (enabledMDOId) => {
      var _a2;
      return enabledMDOId === ((_a2 = warehouse == null ? void 0 : warehouse.pickUpCenters) == null ? void 0 : _a2[0]);
    }
  );
  if (!isWarehouseEnabled || !(inventoryData == null ? void 0 : inventoryData.length) || !city) return null;
  const { isSwatchable, productAttributes, childCatalogData } = item;
  const wioProgramType = checkProgramTypeKeyExists(
    item,
    ProgramTypeVariants.IN_WAREHOUSE
  );
  const bopiwProgramType = checkProgramTypeKeyExists(
    item,
    ProgramTypeVariants.USE_WAREHOUSE_INVENTORY
  );
  const bopimProgramType = checkProgramTypeKeyExists(
    item,
    ProgramTypeVariants.LTL_PICKUP
  );
  const shipToWarehouseProgramType = ((_h = (_g = (_f = (_e = productAttributes == null ? void 0 : productAttributes[0]) == null ? void 0 : _e.object) == null ? void 0 : _f.find((attr) => attr.key === ATTRIBUTE_DELIVERY_TYPE)) == null ? void 0 : _g.value) == null ? void 0 : _h.toLowerCase()) === ATTRIBUTE_WAREHOUSE_PICK_UP_VALUE;
  const currentItemInventoryData = hasSingleSku && ((_j = (_i = inventoryData == null ? void 0 : inventoryData.filter(
    (inventoryItem) => {
      var _a2;
      return (inventoryItem == null ? void 0 : inventoryItem.itemNumber) === ((_a2 = childCatalogData == null ? void 0 : childCatalogData[0]) == null ? void 0 : _a2.id);
    }
  )) == null ? void 0 : _i[0]) == null ? void 0 : _j.programTypes) || {};
  const inWarehouseAvailability = (_k = currentItemInventoryData == null ? void 0 : currentItemInventoryData.inWarehouse) == null ? void 0 : _k.availability;
  const bopimAvailability = (_l = currentItemInventoryData == null ? void 0 : currentItemInventoryData.ltlpickup) == null ? void 0 : _l.availability;
  const deliveryAvailability = ((_m = currentItemInventoryData == null ? void 0 : currentItemInventoryData.locationControlledInventory) == null ? void 0 : _m.availability) || ((_n = currentItemInventoryData == null ? void 0 : currentItemInventoryData.siteControlledInventory) == null ? void 0 : _n.availability);
  if (!hasSingleSku && isSwatchable && showMultiVariantsAvailability && (isBOPIWWarehouseEnabled && bopiwProgramType || isWIOWarehouseEnabled && wioProgramType)) {
    return {
      status: WarehouseChannelBadgeStatus.SEE_PRODUCT_DETAILS,
      warehouse: city
    };
  } else if (hasSingleSku && isBOPIWWarehouseEnabled && bopiwProgramType && inWarehouseAvailability === StockVariants.IN_STOCK) {
    return {
      status: WarehouseChannelBadgeStatus.IN_STOCK_PICK_UP,
      warehouse: city
    };
  } else if (hasSingleSku && isWIOWarehouseEnabled && wioProgramType && inWarehouseAvailability === StockVariants.IN_STOCK) {
    return {
      status: WarehouseChannelBadgeStatus.IN_STOCK_IN_WAREHOUSE,
      warehouse: city
    };
  } else if (hasSingleSku && isWIOWarehouseEnabled && wioProgramType && inWarehouseAvailability === StockVariants.LOW_STOCK) {
    return {
      status: WarehouseChannelBadgeStatus.LOW_STOCK_IN_WAREHOUSE,
      warehouse: city
    };
  } else if (hasSingleSku && isBOPIMEnabled && bopimProgramType && bopimAvailability !== StockVariants.NO_STOCK) {
    return {
      status: WarehouseChannelBadgeStatus.IN_STOCK_MDO_PICK_UP
      // warehouse: city,
    };
  } else if (hasSingleSku && shipToWarehouseProgramType && deliveryAvailability !== StockVariants.NO_STOCK) {
    return {
      status: WarehouseChannelBadgeStatus.SHIPS_TO_WAREHOUSE,
      warehouse: city
    };
  } else if (hasSingleSku && (isWIOWarehouseEnabled && wioProgramType || isBOPIWWarehouseEnabled && bopiwProgramType) && inWarehouseAvailability === StockVariants.NO_STOCK) {
    return {
      status: WarehouseChannelBadgeStatus.OUT_OF_STOCK,
      warehouse: city
    };
  }
  return null;
};
const getImageUrlPCP = (item) => {
  var _a, _b;
  if (!(item == null ? void 0 : item.imageName) && !((_a = item == null ? void 0 : item.descriptions) == null ? void 0 : _a[0].object.imageName)) {
    return null;
  }
  const imageName = (item == null ? void 0 : item.imageName) || ((_b = item == null ? void 0 : item.descriptions) == null ? void 0 : _b[0].object.imageName);
  const isBfldrImgUrl = isValidUrl(imageName);
  if (isBfldrImgUrl) {
    return imageName;
  }
  return null;
};
const getPillBadges = (item, pillBadgeConfig, domainUrl, keyword) => {
  var _a, _b, _c, _d;
  if (!item.productAttributes || !((_a = item.productAttributes) == null ? void 0 : _a[0].object.length))
    return null;
  const { defaultColor, colorMap, catalogSearchUrl } = pillBadgeConfig || {};
  return (_d = (_c = (_b = item.productAttributes) == null ? void 0 : _b[0].object) == null ? void 0 : _c.filter((item2) => item2.isPills)) == null ? void 0 : _d.map((item2) => {
    var _a2, _b2;
    const searchParams = encodeURIComponent(
      ((_a2 = item2.value) == null ? void 0 : _a2.toLocaleLowerCase()) || ""
    );
    const pillBadgeLinkUrl = pillBadgeConfig.isDomainInclusionDisabledByKeyword && !keyword ? `?keyword=${searchParams}` : `${domainUrl}${catalogSearchUrl}${searchParams}`;
    const tranformedColorKey = ((_b2 = item2.value) == null ? void 0 : _b2.replace(/[\s]|[&/\\#,+()$~%.:*?<>{}]/g, "_")) || "";
    const color = (colorMap == null ? void 0 : colorMap[tranformedColorKey]) || defaultColor;
    return {
      color,
      link: pillBadgeLinkUrl.toString(),
      text: item2.value
    };
  });
};
const getMemberOnlyData = (item, childData) => {
  var _a, _b;
  if (!childData || !((_a = childData.catalogData) == null ? void 0 : _a.length)) return false;
  const { dispPriceInCartOnly } = item;
  return (_b = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _b.some((childItem) => {
    return childItem.isMembershipReqd && dispPriceInCartOnly === 1;
  });
};
const getPriceList = (childData, ecoFee) => {
  if (!childData) return [];
  const isBDProduct = isBD();
  const parsedIncludeInPriceEcoFee = (ecoFee == null ? void 0 : ecoFee.includeInPrice) ? parseFloat(ecoFee.includeInPrice) || 0 : 0;
  const extractPrices = (priceOptions, price, displayPrice) => {
    if (price) {
      const parsedPrice = parseFloat(price.toString());
      if (!Number.isNaN(parsedPrice) && parsedPrice > 0) {
        const parsedPriceWithEcoFee = parsedPrice + parsedIncludeInPriceEcoFee;
        const totalDiscount = (displayPrice == null ? void 0 : displayPrice.aggregatedDiscountAmt) ? displayPrice == null ? void 0 : displayPrice.aggregatedDiscountAmt : 0;
        const finalPrice = parsedPriceWithEcoFee - totalDiscount;
        priceOptions.push(finalPrice);
      }
    }
  };
  const getMinPrice = (priceOptions) => {
    return priceOptions.length > 0 ? Math.min(...priceOptions) : void 0;
  };
  const data = childData.catalogData;
  if (!data) return [];
  return data.map((item) => {
    const priceOptions = [];
    if (isBDProduct) {
      const { displayPrice } = item;
      extractPrices(
        priceOptions,
        (displayPrice == null ? void 0 : displayPrice.onlinePrice) ?? "",
        displayPrice
      );
      extractPrices(
        priceOptions,
        (displayPrice == null ? void 0 : displayPrice.deliveredPrice) ?? "",
        displayPrice
      );
    } else {
      const { displayPrice } = item;
      extractPrices(priceOptions, (displayPrice == null ? void 0 : displayPrice.onlinePrice) ?? "");
      extractPrices(priceOptions, (displayPrice == null ? void 0 : displayPrice.deliveredPrice) ?? "");
    }
    return getMinPrice(priceOptions);
  }).filter((value) => value !== void 0);
};
const bopiwOrWioInventoryCheck = (bopiWWarehouseEnabled, wioWarehouseEnabled, pType, programTypeObj) => {
  const bopiCheck = bopiWWarehouseEnabled && (pType.toLowerCase() === ProgramTypeVariants.IN_WAREHOUSE.toLowerCase() || pType.toLowerCase() === ProgramTypeVariants.USE_WAREHOUSE_INVENTORY.toLowerCase()) && getProgramTypeAvailability(
    programTypeObj[pType] || {}
  );
  const wioCheck = wioWarehouseEnabled && pType.toLowerCase() === ProgramTypeVariants.IN_WAREHOUSE.toLowerCase() && getProgramTypeAvailability(
    programTypeObj[pType] || {}
  );
  return bopiCheck || wioCheck;
};
const getProductDeliveryBadgeData = (item, translationsConfig, baseUrl) => {
  const { urls } = translationsConfig || {};
  const checkTwoDayDeliveryExists = checkProgramTypeKeyExists(
    item,
    ProgramTypeVariants.TWO_DAY_DELIVERY
  );
  const checkCostcoGroceryExists = checkProgramTypeKeyExists(
    item,
    ProgramTypeVariants.COSTCOGROCERY
  );
  if (checkTwoDayDeliveryExists || checkCostcoGroceryExists) {
    return {
      linkUrl: `${baseUrl}${(urls == null ? void 0 : urls.groceryURL) || ""}`
    };
  }
  return null;
};
const getProductFeaturesData = (featuresData) => {
  if (featuresData) {
    const result = featuresData.split(";").map((str) => {
      return str.replace(/\n$/, "").trim();
    }).filter((str) => str);
    return result;
  }
  return null;
};
const getProductActions = (catalogItem, featureToggleConfig, translationsConfig, hasUserSignedId, wioWarehouseEnabled, bopiwWarehouseEnabled, hasSingleSku, wcMemberValue, inventoryData, childData, isSponsored, cookieContext, isProductDetailsPage) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { isMembershipReqd, dispPriceInCartOnly, isBuyable, id, startDate } = catalogItem;
  const { tobaccoInState } = translationsConfig;
  const COMING_SOON_FEATURE_ENABLED = featureToggleConfig == null ? void 0 : featureToggleConfig.comingSoonBanner.featureOn;
  const isPurchasable = isBuyable && ((_a = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _a.some((cItem) => cItem.isBuyable));
  const enableAddButton = isPurchasable && (childData == null ? void 0 : childData.catalogData) && (childData == null ? void 0 : childData.catalogData.length) <= 1;
  const checkInStockInventory = () => {
    if (isBD() && isSponsored) {
      return true;
    }
    if (!inventoryData) return false;
    const inventoryProgramTypesSet = /* @__PURE__ */ new Set([
      ProgramTypeVariants.TWO_DAY_DELIVERY,
      ProgramTypeVariants.LOCATION_CONTROLLED_INVENTORY,
      ProgramTypeVariants.SITE_CONTROLLED_INVENTORY
    ]);
    return inventoryData.some((item) => {
      const { programTypes } = item;
      for (const pType in programTypes) {
        if (inventoryProgramTypesSet.has(
          pType
        ) && getProgramTypeAvailability(
          programTypes[pType] || {}
        ) || bopiwOrWioInventoryCheck(
          bopiwWarehouseEnabled,
          wioWarehouseEnabled,
          pType,
          programTypes
        )) {
          return true;
        }
      }
      return false;
    });
  };
  const inStock = checkInStockInventory() || ((_b = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _b.some((cItem) => {
    const { isDispOnZeroInv, backorderableType, backorderQuantity } = cItem;
    return isDispOnZeroInv && backorderableType && backorderableType > 0 && backorderQuantity && backorderQuantity > 0;
  }));
  const currentTimeStamp = /* @__PURE__ */ new Date();
  const comingSoon = COMING_SOON_FEATURE_ENABLED && (startDate ? new Date(startDate) > currentTimeStamp : false);
  const { bdDeliveryLocation, wcMember } = cookieContext || {};
  const displayBDAddToCart = isBD() && ((bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.zipCode) && isMembershipReqd && dispPriceInCartOnly === 0 || hasUserSignedId || hasMembershipId((wcMember == null ? void 0 : wcMember.value) || "")) && isBuyable && inStock;
  const displayBDSignInButton = isBD() && getMemberOnlyData(catalogItem, childData) && (!hasUserSignedId && !hasMembershipId(wcMemberValue) || "");
  const childAdditionalFieldData = (_c = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _c[0];
  const displayBDSignInForDetails = isBD() && (bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.zipCode) && getMemberOnlyData(catalogItem, childData) || isBD() && isBuyable && hasSingleSku && ((catalogItem == null ? void 0 : catalogItem.productClassType) === PRODUCT_CLASS_TYPE_TOBACCO || (catalogItem == null ? void 0 : catalogItem.productClassType) === PRODUCT_CLASS_TYPE_TOBACCO || (catalogItem == null ? void 0 : catalogItem.as400CatCode) === AS400_CAT_CODE_EBB && (catalogItem == null ? void 0 : catalogItem.as400DeptName) === AS400_DEPT_NAME_11 || (childAdditionalFieldData == null ? void 0 : childAdditionalFieldData.as400CatCode) === AS400_CAT_CODE_EBB && (childAdditionalFieldData == null ? void 0 : childAdditionalFieldData.as400DeptName) === AS400_DEPT_NAME_11) && ((_d = bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.bdLocation) == null ? void 0 : _d.includes(
    tobaccoInState == null ? void 0 : tobaccoInState.split("|")[1]
  ));
  if (getMemberOnlyData(catalogItem, childData) && !hasUserSignedId || displayBDSignInButton || displayBDSignInForDetails) {
    return { type: productActionsVariant.SignInButton };
  } else if (((catalogItem == null ? void 0 : catalogItem.dispPriceInCartOnly) === 0 || hasUserSignedId && getMemberOnlyData(catalogItem, childData) && hasMembershipId((wcMember == null ? void 0 : wcMember.value) || "") || hasUserSignedId && !getMemberOnlyData(catalogItem, childData)) && enableAddButton && inStock && !comingSoon || displayBDAddToCart) {
    return {
      contractIdentifier: checkProgramTypeKeyExists(
        catalogItem,
        ProgramTypeVariants.TWO_DAY_DELIVERY
      ) ? "Regional" : void 0,
      itemNumber: (_f = (_e = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _e[0]) == null ? void 0 : _f.id,
      maxQuantity: catalogItem == null ? void 0 : catalogItem.maxItemOrderQty,
      minQuantity: catalogItem == null ? void 0 : catalogItem.minItemOrderQty,
      partNumber: id,
      type: productActionsVariant.QuantitySelector
    };
  } else if (isBD() && !inStock && isPurchasable) {
    return { type: productActionsVariant.OutOfStock };
  } else if (isProductDetailsPage && isPurchasable) {
    return {
      type: (((_g = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _g.length) ?? 0) > 1 ? productActionsVariant.SelectOptions : productActionsVariant.SeeDetails
    };
  } else if (!inStock && isPurchasable) {
    return { type: productActionsVariant.SeeDetails };
  } else {
    return { type: productActionsVariant.SelectOptions };
  }
};
const getDiscountsData = (item) => {
  var _a;
  if (!item || !item.displayPrice) return null;
  return {
    displayDiscount: isBD(),
    totalDiscount: (_a = item.displayPrice) == null ? void 0 : _a.aggregatedDiscountAmt
  };
};
const getPriceData = (item, hasSingleSku, cookieContext, childData, ecoFee, signedIn, isProductDetailsPage) => {
  var _a, _b, _c;
  const { wcMember } = cookieContext;
  if (!hasMembershipId(wcMember.value, signedIn, isProductDetailsPage) && getMemberOnlyData(
    item,
    Array.isArray(childData) ? childData[0] : childData
  ))
    return null;
  const { dispPriceInCartOnly, productAttributes } = item;
  const priceList = getPriceList(
    Array.isArray(childData) ? childData[0] : childData,
    ecoFee
  ) || [];
  const toLowerCaseProgramType = programTypeToLowercase(item);
  const acceptedProgramTypes = [
    ProgramTypeVariants.LOCATION_CONTROLLED_INVENTORY,
    ProgramTypeVariants.TWO_DAY_DELIVERY,
    ProgramTypeVariants.SITE_CONTROLLED_INVENTORY,
    ProgramTypeVariants.STANDARD,
    ProgramTypeVariants.NATIONAL,
    ProgramTypeVariants.SAME_DAY_DELIVERY
  ];
  const programTypeCheck = isBD() ? true : acceptedProgramTypes.some(
    (type) => toLowerCaseProgramType == null ? void 0 : toLowerCaseProgramType.includes(type.toLowerCase())
  );
  if (programTypeCheck && dispPriceInCartOnly !== 2 && priceList.length) {
    const hasPriceRangeAttr = ((_c = (_b = (_a = productAttributes == null ? void 0 : productAttributes[0]) == null ? void 0 : _a.object) == null ? void 0 : _b.find(
      (attr) => attr.key === ATTRIBUTE_HIDE_PRICE_RANGE_KEY
    )) == null ? void 0 : _c.value) === ATTRIBUTE_1_VALUE;
    const minSalePrice = Math.min(...priceList);
    const maxSalePrice = Math.max(...priceList);
    if (!hasSingleSku) {
      if (hasPriceRangeAttr && minSalePrice < maxSalePrice) {
        return {
          priceText: "Starting at",
          priceValue: minSalePrice
        };
      } else if (minSalePrice === maxSalePrice) {
        return {
          priceText: null,
          priceValue: minSalePrice
        };
      } else {
        return {
          priceText: null,
          priceValue: [minSalePrice, maxSalePrice]
        };
      }
    } else {
      return {
        priceText: null,
        priceValue: minSalePrice
      };
    }
  }
  return null;
};
const getAddToListButtonData = (item, productName, hasSingleSku, cookieContent, childData) => {
  var _a;
  const imageUrl = getImageUrlPCP(item);
  const price = getPriceData(item, hasSingleSku, cookieContent, childData);
  const { productClassType, isBuyable, productAttributes } = item;
  const isBundle = (_a = productAttributes == null ? void 0 : productAttributes[0]) == null ? void 0 : _a.object.some(
    (attr) => attr.key === ATTRIBUTE_BUNDLE
  );
  if (hasSingleSku && isBuyable && !PRODUCT_CLASS_TYPES.includes(productClassType || "") && !isBundle) {
    return {
      image: imageUrl,
      name: productName,
      price: price == null ? void 0 : price.priceValue
    };
  }
  return null;
};
export {
  getAddToListButtonData,
  getChdiEligibility,
  getColorSwatchesData,
  getCompareProductButtonData,
  getDeliveryChannelBadgeData,
  getDiscountsData,
  getFsaEligibility,
  getImageUrlPCP,
  getInWareHouseChannelBadgeData,
  getInWarehouseAvailabilityText,
  getMemberOnlyData,
  getPillBadges,
  getPriceData,
  getPriceList,
  getProductActions,
  getProductDeliveryBadgeData,
  getProductFeaturesData,
  getProgramTypeAvailability,
  getReplacementItemNumber,
  getReviewRatingData,
  parseBatchedItemResponse,
  programTypeToLowercase
};
